import React from "react";
import { NavBar, Icon, Toast } from "antd-mobile";
import Quagga from "@ericblade/quagga2";
// import Quagga from '../../lib/3rd/quagga.js';
import {
  getMenu,
  customerModel,
  getLog,
  getLanguageList,
  getProductBySn,
} from "../../ajax/index.js";
import { Link } from "react-router-dom";
import { changeMeta, IsPC } from "../../common/Method.js";

import $ from "../../ajax/ajax.js"; // 合并遗漏
import { createHashHistory } from "history";
const history = createHashHistory();

class appHome extends React.Component {
  constructor(porps) {
    super(porps);
    this.state = {
      MenuData: [],
      LanguageList: [], //多语言列表
      languageName: "",
      hasbg: true, //判断背景图是否存在
      isVideo: false, //是否有摄像头
    };
  }
  componentDidMount() {
    sessionStorage.setItem("searchKeyword", "");
    // document.documentElement.setAttribute('data-scale', true);
    // let _head = document.getElementsByTagName('head')[0];
    // _head.innerHTML += `<meta name="viewport" content="width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">  `

    //获取语言列表
    getLanguageList("TSP_SOLUTION_LANGUAGE").then((res) => {
      this.setState({
        LanguageList: res.data,
      });
    });
    //发送埋点日记
    let currentUrl = window.location.href;
    let appId = "tsp.errorcode";
    let pointName = "#home";
    getLog(currentUrl, appId, pointName);
    // 读取本地缓存语言 默认上一次选中语言
    let language = localStorage.getItem("language");
    if (!language) {
      //获取浏览器语言
      // language = navigator.language.slice(0, 2);
      language = "en"; //默认英文
    }
    this.getMenudata(language);

    console.log("ttttttttttt", IsPC());
    // 判断是否是手机端打开
    if (!IsPC()) {
      this.setState({
        isVideo: true,
      });
      return;
    }

    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      console.log("不是https, 不安全，不支持 enumerateDevices() .");
      return;
    }
    let _this = this;

    // 获取设备列表。
    navigator.mediaDevices
      .enumerateDevices()
      .then(function (devices) {
        console.log("wwwwwwwwwwwwww", devices);

        let isVideo = false;
        devices.forEach((v) => {
          // 是否有摄像头
          if (v.kind === "videoinput") {
            isVideo = true;
          }
        });

        _this.setState({
          isVideo,
        });
      })
      .catch(function (err) {
        console.log(err.name + ": " + err.message);
      });
  }
  //根据语言，获取分类列表
  getMenudata = (language) => {
    getMenu(language).then((res) => {
      this.setState({
        MenuData: res.data,
        languageName: language,
      });
      let url = "/tsp/resource/images/solutionLanguage/" + language + ".png";
      const img = new Image();
      img.src = url;
      setTimeout(() => {
        if (img.height > 0 || img.width > 0) {
          this.setState({
            hasbg: true,
          });
        } else {
          this.setState({
            hasbg: false,
          });
        }
      }, 100);
    });
  };
  //通过条码查询机器型号
  getMachineModelbyBarCode(data) {
    let _this = this;
    let productSerial = data.replace(/\s/g, "").substr(3, 8);
    getProductBySn(productSerial)
      .then((res) => {
        Toast.hide();
        if (res.resultCode === "ISC-000" && res.data.length) {
          _this.hanldScan(res.data[0].productId);
        } else {
          alert(" No product information for this product.");
          Toast.hide();
        }
      })
      .catch(() => {
        Toast.hide();
      });
  }

  //处理扫码结果
  hanldScan(productId) {
    Toast.hide();
    productId && history.push(`/productDetail/${productId}`);
    //发送埋点日记
    let currentUrl = window.location.href;
    let appId = "tsp.errorcode";
    let pointName = `/seachlist?scan`;
    getLog(currentUrl, appId, pointName);
  }

  /*显示loading框*/
  loadingToast() {
    Toast.loading(
      "Loading...",
      50000,
      () => {
        console.log("Load complete !!!");
      },
      true
    );
  }

  /*开始识别*/
  scan(data) {
    let _this = this;
    Quagga.decodeSingle(
      {
        decoder: {
          readers: ["code_128_reader"], // List of active readers
        },
        locate: true, // try to locate the barcode in the image
        src: data, // or 'data:image/jpg;base64,' + data
      },
      function (result) {
        if (result && result.codeResult) {
          alert(result.codeResult.code);
          _this.getMachineModelbyBarCode(result.codeResult.code); // 去搜索扫码结果
        } else {
          //第一次识别不到有可能是角度不对，需要旋转90度继续识别
          Toast.hide();
          alert("Unrecognized, please provide correct Midea product barcode.");
        }
      }
    );
  }
  /*图片发生改变的时候*/
  change(e) {
    let _this = this;
    let file = e.target.files[0];
    if (!file) return;
    _this.loadingToast();
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (data) {
      _this.scan(data.target.result);
    };
  }
  /*提示三次*/
  showTip() {
    if (this.state.isVideo) {
      history.push(`/scan`);
    }
  }

  selectonChange = (e) => {
    e.persist();
    let language = e.target.value.split(",")[1];
    //将选中的语言保存到本地
    localStorage.setItem("language", language);
    this.getMenudata(language);
  };

  // 上传文件
  handleImageChange = (e) => {
    e.preventDefault();
    let _this = this;

    let file = e.target.files[0];
    let formData = new FormData();
    formData.append("file", file);

    let reader = new FileReader(); //实例化文件读取对象
    reader.readAsDataURL(file); //将文件读取为 DataURL,也就是base64编码
    reader.onload = function (ev) {
      //文件读取成功完成时触发
      var dataURL = ev.target.result; //获得文件读取成功后的DataURL,也就是base64编码
      _this.scan(dataURL);
    };
  };

  hangdleLinkTO = (id, language) => {
    let url = `/MenuIndex/${id},${language}`;
    history.push(url);
  };
  render() {
    // 读取本地缓存语言 默认上一次选中语言
    let language = localStorage.getItem("language");
    if (!language) {
      //获取浏览器语言
      // language = navigator.language.slice(0, 2);
      language = "en";
    }
    changeMeta(this.props.match.path);
    let qr = require("../../assets/images/home/icon_barcode.png"); // 合并遗漏
    let src =
      "/tsp/resource/images/solutionLanguage/" +
      this.state.languageName +
      ".png";
    let nosrc = require("../../assets/images/home/select_bg.jpg");
    let imgsrc = this.state.hasbg ? src : nosrc;
    const select = (
      <select
        onChange={(e) => this.selectonChange(e)}
        style={{ backgroundImage: `url("${imgsrc}")` }}
        className="select-bg"
      >
        <option className="first-opt" key="first"></option>
        {this.state.LanguageList.map((item, key) => {
          return (
            <option
              key={key}
              value={item.name + "," + item.value}
              className="color"
            >
              {item.name}
            </option>
          );
        })}
      </select>
    );
    return (
      <div className="transition-item">
        <div className="home-style homeWrap">
          <NavBar
            mode="dark"
            leftContent={[
              <span key="0" style={{ fontSize: "18px" }}>
                TSP
              </span>,
            ]}
            rightContent={[
              select,
              <Icon type="down" size="xxs" className="down-class" />,
              <div
                className="qrcodeWrap"
                to="qrcode"
                key="1"
                onClick={() => {
                  this.showTip();
                }}
              >
                <img key="1" width="30" src={qr} alt="图片" />
                {this.state.isVideo ? (
                  ""
                ) : (
                  <input
                    type="file"
                    className="imgLocal"
                    accept="image/*"
                    onChange={(e) => this.handleImageChange(e)}
                  />
                )}
              </div>,
            ]}
          >
            <Link
              to="/seachlist"
              style={{
                width: "100%",
                height: "100%",
                lineHeight: "28px",
                color: "rgba(0,0,0,0.26)",
                textAlign: "left",
              }}
            >
              <Icon key="0" type="search" className="input-search" />
              Search Model / Barcode / SN
            </Link>
          </NavBar>
          <div style={{ padding: "10px 10px" }}>
            <ul className="productcategory-list">
              {this.state.MenuData.map((i) => {
                return (
                  <li className="box-s" key={i.id}>
                    <a
                      onClick={() => {
                        this.hangdleLinkTO(i.id, language);
                      }}
                    >
                      <div className="list-img">
                        <img src={i.picUrl} alt="img" />
                      </div>
                      <div className="list-text">
                        <div className="middle">{i.name}</div>
                      </div>
                    </a>
                  </li>
                );
              })}
              <div className="clear"></div>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
export default appHome;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js